import SignatureAnimation from './signature.json'

export default {
  signature: {
    component: SignatureAnimation,
  },
}
